module.exports = __webpack_public_path__ + "static/media/Logo.b218e1ba.png";